import { useEffect } from "react";

function isUrlOnlySelection(text: string): boolean {
  const trimmed = text.trim();
  if (!trimmed || trimmed.includes("\n")) return false;

  if (/^https?:\/\/\S+$/i.test(trimmed)) return true;

  if (trimmed.startsWith("/") && !trimmed.includes(" ")) {
    return true;
  }

  try {
    new URL(trimmed);
    return true;
  } catch {
    return false;
  }
}

function shouldSkipCopyPrevention(target: Element): boolean {
  if (target.closest(".comment__container")) return true;
  if (target.closest("input, textarea, select, [contenteditable='true'], [contenteditable='']")) {
    return true;
  }
  return false;
}

export const usePreventCopy = (maxCopyLength: number, creditMessage: string) => {
  useEffect(() => {
    const handleCopy = (event: ClipboardEvent) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (shouldSkipCopyPrevention(target)) return;

      const selection = window.getSelection();
      if (!selection || selection.isCollapsed) return;

      const selectedText = selection.toString();
      if (!selectedText.trim()) return;
      if (isUrlOnlySelection(selectedText)) return;

      let limitedText = selectedText;
      if (selectedText.length > maxCopyLength) {
        limitedText = `${selectedText.slice(0, maxCopyLength)}...`;
      }

      const finalText = creditMessage ? `${limitedText}\n\n${creditMessage}` : limitedText;

      event.clipboardData?.setData("text/plain", finalText);
      event.preventDefault();
    };

    document.addEventListener("copy", handleCopy);

    return () => {
      document.removeEventListener("copy", handleCopy);
    };
  }, [maxCopyLength, creditMessage]);
};
